export default __webpack_public_path__ + "static/media/bbu.a42e9958.png";